import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import { ShiftBadge } from 'ui'
import { Collection, WhenModelValue } from '@morningtrain/react-resources'
import { EnvFilter } from 'support/filters'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import EconomyChecklistProgress from 'widgets/economy/partials/EconomyChecklistProgress'
import { Link } from '@morningtrain/react-navigation'
import { StaticFilter } from '@morningtrain/react-filters'

export default function AllChecklistsSmartview () {
  return (
    <Translator namespace='economy.checklists'>
      <Smartview
        tight
        size='sm'
        header={(
          <UI.SecondaryHeading>
            <Translation name='title'/>
          </UI.SecondaryHeading>
        )}
      >

        <Collection resourceName='economy' operationName='checklists' operationContext={{ context: 'smartview' }}>
          <EnvFilter name='period' envKey='page.filters.period'/>
          <StaticFilter name='with_latest_miss' value={1}/>

          <Table striped headless className='-mt-4'>
            <Columns.Column label=''>
              <UI.SpaceBetween>
                <div className='flex'>
                  <WhenModelValue name='badge.badge'>
                    <ShiftBadge name='badge.badge' className='-mt-1 mr-1'/>
                  </WhenModelValue>
                  <Link route='app.checklists_for_department' parameters={{ department: 'model:id' }}>
                    <UI.Text weight='medium'>
                      <Displays.Text name='name'/>
                    </UI.Text>
                  </Link>
                </div>
                <div className='flex w-1/2'>
                  <EconomyChecklistProgress/>
                  <Displays.Percentage className='w-10 font-medium' alignment='right' name='checklist_progress' label=''
                                       decimals={0}/>
                </div>
              </UI.SpaceBetween>
              <UI.SpaceBetween>
                <UI.Text size='xs'>
                  <Translation name='last_miss'/>
                  <span>: </span>
                </UI.Text>
                <UI.Text size='xs'>
                  <Displays.Text name='latest_miss_at'/>
                </UI.Text>
              </UI.SpaceBetween>
            </Columns.Column>
          </Table>
        </Collection>

      </Smartview>
    </Translator>
  )
}
